import React from 'react'

import { Box, Typography, makeStyles } from '@material-ui/core'
import { orderStatusToTextMap, orderStatusToTextMapEng } from '../utility/trackingUtility'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles((theme) => ({
    root: {
        // maxHeight: '900px',
        // overflow: 'scroll',

        // position: 'relative',
    },
    content: {
        '& > div': {
            margin: '20px 0'
        }
    }
}))

const CardContainer = ({ children }) => {
    const classes = useStyles()
    const { t, i18n } = useTranslation('tracking')

    return (
        <Box className={classes.root}>
            <Box className={classes.content}>
                {children}
            </Box>
        </Box>
    )
}

export default CardContainer